<template>
  <div>
    <my-lessons-desktop v-if="screenType === 'desktop'" :details="details" :class-id="classId" :course-id="courseId"
                        :course-name="course.title"></my-lessons-desktop>
    <my-lessons-mobile v-else :details="details" :class-id="classId" :course-id="courseId"
                       :course-name="course.title"></my-lessons-mobile>
  </div>
</template>

<script>
import MyLessonsDesktop from "@/components/Pages/Desktop/Dashboard/Lessons/MyLessonsDesktop";
import MyLessonsMobile from "@/components/Pages/Mobile/Dashboard/Lessons/MyLessonsMobile";
import Echo from "laravel-echo";

export default {
  name: "MyLessonsMain",
  components: {MyLessonsMobile, MyLessonsDesktop},
  data() {
    return {
      courseId: null,
      details: [],
      classId: null,
      course: null,
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop',
    }
  },
  mounted() {
    this.courseId = this.$route.params.courseId
    this.classId = this.$route.params.classId
    this.getLessons()
    this.getCourseInfo()
    this.initialWS()
    this.initialListenWs()
  },
  methods: {
    initialWS() {
      if (!this.$store.state.user) {
        return
      }
      this.$store.state.Echo = new Echo({
        broadcaster: 'pusher',
        key: 'myKey',
        cluster: 'mt1',
        wsHost: process.env.VUE_APP_WS_HOST,
        wsPort: process.env.VUE_APP_WS_PORT,
        forceTLS: process.env.VUE_APP_FORCE_TLS !== 'false',
        disableStats: true,
        encrypted: true,
        auth: {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        },
        authorizer: (channel) => {
          return {
            authorize: (socketId, callback) => {
              window.mainAxios.post('/api/students/broadcasting/auth', {
                socket_id: socketId,
                channel_name: channel.name
              }, {
                headers: {
                  Authorization: this.$cookies.get('token')
                }
              })
                  .then(response => {
                    callback(false, response.data);
                  })
                  .catch(error => {
                    callback(true, error);
                  });
            }
          };
        },
      });
      this.$store.state.loadingEcho = false
    },
    listenWs(type) {
      if (type === 'immediately') {
        this.$store.state.Echo.private('send.notification.' + this.$store.state.user.id)
            .listen('SendNotification', () => {
              this.getLessons()
              this.getCourseInfo()
            })
      } else {
        let self = this
        window.setTimeout(function () {
          self.$store.state.Echo.private('send.notification.' + self.$store.state.user.id)
              .listen('SendNotification', (event) => {
                self.getLessons()
                self.getCourseInfo()
                console.log(event, 'new')
              })
        }, 3000)
      }
    },
    initialListenWs() {
      if (!this.$store.state.user) {
        return
      }
      if (!this.$store.state.loadingEcho) {
        this.listenWs('immediately')
      } else {
        this.listenWs('wait')
      }
    },
    getLessons() {
      window.axios.get('student/courses/lessons/index/all/' + this.courseId).then((res) => {
        this.details = res.data.data
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
        let self = this
        window.setTimeout(function () {
          self.$router.push('/dashboard/subscriptions')
        }, 3500)
      })
    },
    getCourseInfo() {
      window.axios.get('student/courses/get/' + this.courseId).then((res) => {
        this.course = res.data.data
      })
    }
  }
}
</script>

<style scoped>

</style>